import { render, staticRenderFns } from "./Game_Coupon.vue?vue&type=template&id=54bdc8b1&scoped=true&"
import script from "./Game_Coupon.vue?vue&type=script&lang=js&"
export * from "./Game_Coupon.vue?vue&type=script&lang=js&"
import style0 from "./Game_Coupon.vue?vue&type=style&index=0&id=54bdc8b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bdc8b1",
  null
  
)

export default component.exports